import { render } from "./PlanCargoSettingsItemCreateEditDialog.vue?vue&type=template&id=89706156&scoped=true&ts=true"
import script from "./PlanCargoSettingsItemCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./PlanCargoSettingsItemCreateEditDialog.vue?vue&type=script&lang=ts"

import "./PlanCargoSettingsItemCreateEditDialog.vue?vue&type=style&index=0&id=89706156&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89706156"]])

export default __exports__